import { render, staticRenderFns } from "./ListContact.vue?vue&type=template&id=fefad398"
import script from "./ListContact.vue?vue&type=script&lang=js"
export * from "./ListContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports